import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { onBeforeRouteLeave, useRouter, userRoute } from 'vue-router';
import { defineComponent, getCurrentInstance, toRefs, reactive, computed, watch, nextTick, onActivated } from 'vue';
import { useStore } from '@/store/index';
import { AppActionTypes } from '@/store/modules/app/action-types';
import { joinParams } from '@/utils/index';
import Keys from '@/constant/key';
import { DelayStatus, DelayTypes, OrderPickStatus, OrderStatus } from '@/enums/order';
import { getDelayTime, dateFormat, getLastMonthToday, getCurrentDate } from '@/utils/index';
import Pagination from '@/components/Pagination';
import { isSensitive } from '@/utils/validator';
import { saveDistributeApi, pickOrderApi, getExpressInfoApi } from '../../apis/order';
import { getPickShopListApi, getDistributeShopListApi } from '../../apis/shop';
import FollowWxDialog from '@/components/FollowWxDialog';
import { deliveryTypes } from './enum';
import { ElMessageBox } from 'element-plus';
import SelectMerchantSecondBrand from '@/components/SelectMerchantSecondBrand';
import { isValidTel, isValidMobile } from '@/utils/validator';
export default defineComponent({
  name: 'MerchantList',
  components: {
    Pagination,
    FollowWxDialog,
    SelectMerchantSecondBrand
  },
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const {
      o
    } = route.query;
    let check_zh = (rule, val, callback) => {
      if (!/[\u4E00-\u9FA5A-Za-z]/g.test(val)) {
        callback(new Error('只能是汉字或英文'));
      }
      callback();
    };
    const disabledDate = date => {
      // 今天可选
      return date.getTime() + 1000 * 60 * 60 * 24 < Date.now();
    };
    // 支付开始时间限制：非历史订单时只能选择 2026-01-01 及以后
    const disabledStartDate = date => {
      if (state.filters.is_history) return false;
      const limitDate = new Date('2026-01-01');
      return date.getTime() < limitDate.getTime();
    };
    // 支付结束时间限制：历史订单时只能选择 2026-01-01 之前
    const disabledEndDate = date => {
      if (!state.filters.is_history) return false;
      const limitDate = new Date('2026-01-01');
      return date.getTime() >= limitDate.getTime();
    };
    const hasShop = store.state.user.userInfo.hasShop;
    const is_allocation = store.state.user.userInfo.is_allocation; // 针对指定商家开发自主接单功能
    const today = new Date();
    const state = reactive({
      srcList: [],
      o: route.query.o || null,
      filters: {
        order_type: route.query.all || !is_allocation ? 1 : hasShop ? 0 : 5,
        is_yushou: route.query.is_yushou || 0,
        tmp_secondary_id: [],
        yushou_start_date: '',
        yushou_end_date: '',
        order_no: '',
        name: '',
        delivery_type: route.query.t || '',
        phone: '',
        reject_status: '',
        time_type: '',
        start_date: route.query.start_date || getLastMonthToday(),
        end_date: route.query.end_date || getCurrentDate(),
        item_name: '',
        timeClick: '',
        is_history: false,
        shop_user_id: undefined,
        limit: 10,
        page: 1
      },
      noticeArray: ['该品仅限京东、顺丰发货', '该品仅限京东物流发货', '该品仅限顺丰发货'],
      displayMessage: '',
      //京东、顺丰物流分类提示
      addExpressCp: {
        order_id: '',
        phone: '',
        express_cp: '',
        express_no: '',
        originator_phone: '',
        user_id: '',
        remark: '',
        isNotice: 0,
        ship_type: ''
      },
      addRemark: {
        order_id: '',
        seller_msg: ''
      },
      addDelivery: {
        order_id: '',
        delay_delivery_time: '',
        delay_delivery: ''
      },
      tableData: [],
      isLoading: false,
      // 表格数据加载状态
      shopUserList: [],
      spanArr: null,
      pos: 0,
      count: 0,
      dialogOldFormVisible: false,
      dialogDeliveryFormVisible: false,
      dialogBatchDelivery: false,
      dialogRmarkFormVisible: false,
      //备注弹窗
      batchType: '',
      // 批量发货类型：order-订单，product-商品
      fileList: [],
      // 上传文件信息
      tableHeight: 0,
      // table 动态高度
      currRow: {},
      // 当前操作数据行

      dialogDistributeVisible: false,
      // 分配门店弹框
      distributeShopList: [],
      // 分配门店列表
      distributeShopId: '',
      // 分配门店ID
      expressPhoneError: '',
      // 寄件人电话错误提示

      onSelectedSecondBrandChange(val) {
        state.filters.secondary_id = val.join(',');
      },
      handleSizeChange(val) {
        state.filters.limit = val;
        state.getList();
      },
      handleCurrentChange(val) {
        state.filters.page = val;
        state.getList();
      },
      getList() {
        // state.isLoading = true
        const url = state.filters.is_history ? '/admin/merchant/getOrderLists_history' : '/admin/merchant/getOrderList';
        proxy.$http.get(`${url}?${joinParams(state.filters)}`).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 0) {
            state.tableData = [];
            state.count = 0;
            state.isLoading = false;
            return proxy.$message({
              type: 'error',
              message: res.msg
            });
          }
          state.tableData = data.data;
          state.spanArr = data.data;
          state.count = data.total;
          state.getSpanArr(state.spanArr);
          state.srcList = ['https://img.dangaoss.com/public/p/72/0/1176489_l.jpg'];
          /**
           * 延迟发货状态判断：
           * 未填写：reject_status==0 没有延迟发货信息
           * 待审核状态：reject_status==0 有延迟发货信息
           *      首次提交待审核：没有驳回原因
           *      驳回后再次提交待审核：有驳回原因
           * 驳回：reject_status==3 有延迟发货信息
           * 审核通过：reject_status==1 有延迟发货信息
           * 总结：当状态为待审核或审核通过时不可编辑，即有延迟发货信息且状态不等于 3 时，不可编辑
          */
          // state.tableData.map(item => {
          //     const { id } = item
          //     const fitIndex = state.tableData.findIndex(item => item.id == id && item.delay_delivery_type != 0 && item.reject_status != 3)
          //     item.editable = fitIndex === -1
          // })
          state.tableData.map(item => {
            const {
              ship_type,
              status,
              shop_status,
              express_cp,
              ship_date,
              ship_time_text
            } = item;
            /**
             * 是否可接单
             * */
            let canPick = OrderPickStatus[shop_status] == '未接单' && (hasShop && OrderStatus[status] == '待确认' || !hasShop) && ship_type != 'same';
            // 是否可分配
            let canDistribute = hasShop && OrderStatus[status] == '待确认' && ship_type != 'same';
            // 是否可发货
            let canDelivery = true;
            if (is_allocation) {
              // canDelivery = OrderStatus[status] == '已分配' && (express_cp == '' || express_cp == null) && (hasShop && OrderPickStatus[shop_status] == '总商户接单' || !hasShop && OrderPickStatus[shop_status] == '门店账号接单')
              canDelivery = OrderStatus[status] == '已分配' && (express_cp == '' || express_cp == null);
            } else {
              canDelivery = express_cp == '' || express_cp == null;
            }
            // 是否可签收
            let canSign = ship_type != 'same' && OrderStatus[status] == '已分配' && express_cp && Date.now() > new Date(ship_date + ' ' + ship_time_text.split('-')[0]).getTime() && (hasShop && OrderPickStatus[shop_status] == '总商户接单' || !hasShop && OrderPickStatus[shop_status] == '门店账号接单');
            item.canPick = canPick;
            item.canDistribute = canDistribute;
            item.canDelivery = canDelivery;
            item.canSign = canSign;
          });
          state.isLoading = false;
        });
      },
      search(type) {
        if (type) {
          state.filters.timeClick = type;
          state.filters.start_date = '';
          state.filters.end_date = '';
        }
        state.filters.page = 1;
        state.getList();
      },
      onHistoryChange(val) {
        state.filters.page = 1;
        if (val) {
          state.filters.start_date = '2025-12-01';
          state.filters.end_date = '2025-12-31';
        } else {
          state.filters.start_date = getLastMonthToday();
          state.filters.end_date = getCurrentDate();
        }
        state.getList();
      },
      output() {
        window.open(`${Keys.baseUrl}/admin/merchant/merchantOrderOutput?${joinParams({
          ...state.filters,
          user_id: store.state.user.userInfo.id
        })}`);
      },
      batchDelivery(type) {
        state.batchType = type;
        state.dialogBatchDelivery = true;
      },
      getShopList: () => {
        proxy.$http.get(`/admin/shop_product/getShopList?user_id=${store.state.user.userInfo.id}`).then(res => {
          if (res.code == 200) {
            state.shopUserList = res.data;
          } else {
            state.shopUserList = [];
          }
        });
      },
      // 上传文件超出限制时提示
      handleExceed: () => {
        proxy.$message({
          type: 'warning',
          message: '最多只能上传一个文件'
        });
      },
      // 提交上传
      submitUpload: () => {
        if (state.fileList.length === 0) {
          return proxy.$message({
            type: 'warning',
            message: '请选择文件'
          });
        }
        store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, true);
        proxy.$refs.batchDeliveryForm.submit();
      },
      // 批量发货-上传文件成功
      handleAvatarSuccess: (res, file) => {
        store.dispatch(AppActionTypes.ACTION_SET_GLOBALLOADING, false);
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          ElMessageBox.alert(msg, '提示', {
            confirmButtonText: '知道了',
            type: 'error'
          });
          proxy.$refs.batchDeliveryForm.clearFiles();
          return;
        }
        proxy.$message({
          type: 'success',
          message: '发货成功'
        });
        proxy.$refs.batchDeliveryForm.clearFiles();
        state.dialogBatchDelivery = false;
        setTimeout(() => {
          state.getList();
        }, 2000);
      },
      // 批量发货-关闭弹框
      beforeBatchDialogClose: () => {
        proxy.$refs.batchDeliveryForm.clearFiles();
        state.dialogBatchDelivery = false;
      },
      edit(index, row) {
        var _state$addExpressCp$l, _state$addExpressCp$l2;
        // router.push('/invoice/edit?id='+row.id);
        //数据置空
        state.displayMessage = '';
        state.addExpressCp.isNotice = 0;
        state.addExpressCp.express_cp = '';
        state.addExpressCp.express_no = '';
        state.addExpressCp.originator_phone = '';
        state.addExpressCp.remark = '';
        state.addExpressCp.order_id = row.order_id;
        state.addExpressCp.phone = row.phone;
        state.addExpressCp.user_id = store.state.user.userInfo.id;
        state.addExpressCp.label_name = row.label_name;
        state.addExpressCp.ship_type = row.ship_type;
        state.dialogOldFormVisible = true;
        // 检查是否包含京东或顺丰
        const containsJD = (_state$addExpressCp$l = state.addExpressCp.label_name) === null || _state$addExpressCp$l === void 0 ? void 0 : _state$addExpressCp$l.includes('京东');
        const containsSF = (_state$addExpressCp$l2 = state.addExpressCp.label_name) === null || _state$addExpressCp$l2 === void 0 ? void 0 : _state$addExpressCp$l2.includes('顺丰');

        // 根据是否包含京东或顺丰进行判断
        if (state.addExpressCp.ship_type == 'same') {
          state.addExpressCp.isNotice = containsJD && containsSF ? 1 : containsJD ? 2 : containsSF ? 3 : 0;
        }
      },
      // 打开分配订单弹框
      openDistribute(row, type = '') {
        row.distributeType = type;
        state.currRow = row;
        state.getDistributeShopList(row.order_id, type);
      },
      // 获取可接单/可分配（此类门店关联了门店账号）门店列表
      getDistributeShopList: async (order_id, type) => {
        const {
          code,
          data,
          msg
        } = type == 2 ? await getPickShopListApi(order_id) : await getDistributeShopListApi(order_id);
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        state.distributeShopList = data;
        state.dialogDistributeVisible = true;
      },
      // 确认分配
      onDistribute() {
        const {
          currRow,
          distributeShopId
        } = state;
        const {
          order_id,
          distributeType
        } = currRow;
        if (!distributeShopId) {
          return proxy.$message({
            type: 'error',
            message: '请选择门店'
          });
        }
        saveDistributeApi(order_id, distributeShopId, distributeType).then(res => {
          const {
            code,
            data,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          proxy.$message({
            type: 'success',
            message: '操作成功'
          });
          state.getList();
          state.dialogDistributeVisible = false;
          state.distributeShopId = '';
        });
      },
      // 确认接单
      onPick(order_id) {
        proxy.$confirm('确认接收此单吗？', '提示', {
          type: 'warning'
        }).then(() => {
          pickOrderApi(order_id).then(res => {
            const {
              code,
              data,
              msg
            } = res;
            if (code != 200) {
              return proxy.$message({
                type: 'error',
                message: msg
              });
            }
            proxy.$message({
              type: 'success',
              message: '操作成功'
            });
            state.getList();
          });
        }).catch(() => {
          console.log('取消接单');
        });
      },
      //备注弹窗提交
      submitRemark: () => {
        proxy.$refs['addRemarkForm'].validate(valid => {
          if (valid) {
            isSensitive(state.addRemark.seller_msg).then(res => {
              if (res === true) {
                proxy.$http.post('/admin/merchant/add_seller_msg', state.addRemark).then(res => {
                  const {
                    code,
                    msg
                  } = res;
                  if (code != 200) {
                    return proxy.$message({
                      type: 'error',
                      message: msg
                    });
                  }
                  proxy.$message({
                    type: 'success',
                    message: '备注保存成功'
                  });
                  state.dialogRmarkFormVisible = false;
                  state.getList();
                });
              } else {
                proxy.$message({
                  type: 'error',
                  message: `备注中包含敏感词：${res}`
                });
              }
            });
          }
        });
      },
      //打开备注弹窗
      remarkDialog: row => {
        state.addRemark.order_id = row.order_id;
        state.addRemark.seller_msg = row.seller_msg;
        state.dialogRmarkFormVisible = true;
      },
      // 打开延迟发货弹框
      openDelayDialog: row => {
        state.currRow.order_no = row.order_no;
        state.currRow.paid_at = row.paid_at;
        state.currRow.yushou_end_date = row.yushou_end_date;
        state.dialogDeliveryFormVisible = true;
        nextTick(() => {
          proxy.$refs['addDeliveryForm'].clearValidate();
        });
      },
      /*
      不可选延迟发货的情况
          后端返回is_operate（均为对订单下某个商品的判断返回到订单列表中）
              1.订单包含”预售”和“非预售”商品，请进订单详情操作
              2.订单含有不同预售时间商品，请进订单详情操作
              is_expresses = 1 已退款、已完成、已发货、已部分发货
              3.根据订单下的商品进行状态的判断
                  订单已部分发货，请到详情页进行操作（reject_status！==3（已驳回）时，）
          前端判断
              1.支付时间超48h不支持延迟发货
              预售商品判断（以下两条仅为预售商品的判断，其余以上条件包含全部商品）
              1.预售期间不支持延迟发货（包含预售开始结束当天23:59:59）
              2.预售结束时间超48h不支持延迟发货
      */
      //根据订单判断不可选延迟发货的情况
      onTips: row => {
        if (row.is_operate !== true) {
          return row.is_operate;
        } else if (Boolean(row.is_expresses)) {
          return '当前状态不可操作';
        } else if (!row.yushou_end_date && Date.now() - new Date(row.paid_at).getTime() > 1000 * 60 * 60 * 48) {
          return '支付时间超48h不支持延迟发货';
        } else if (row.yushou_end_date && Date.now() <= new Date(row.yushou_end_date + ' 23:59:59 ').getTime()) {
          return '预售期间不支持延迟发货';
        } else if (row.yushou_end_date && Date.now() >= new Date(row.yushou_end_date + ' 23:59:59 ').getTime() + 1000 * 60 * 60 * 48) {
          return '预售结束时间超48h不支持延迟发货';
        }
      },
      // 延迟发货请求
      onDelaySave: () => {
        proxy.$refs['addDeliveryForm'].validate(valid => {
          if (valid) {
            const {
              order_no,
              delay_delivery_type,
              delay_delivery_time,
              delay_reson
            } = state.currRow;
            proxy.$http.post(`/admin/merchant/delay_delivery`, {
              order_no,
              delay_delivery_type,
              delay_delivery_time,
              delay_reson
            }).then(res => {
              if (res.code != 200) {
                return proxy.$message({
                  type: 'error',
                  message: res.msg
                });
              }
              proxy.$message({
                type: 'success',
                message: '操作成功'
              });
              state.beforeDelayDialogClose();
              state.getList();
            });
          }
        });
      },
      // 关闭延迟发货弹框前清空数据
      beforeDelayDialogClose: () => {
        state.currRow = {};
        state.dialogDeliveryFormVisible = false;
      },
      addDeliveryFun: (index, row) => {
        state.addDelivery.delay_delivery_time = '', state.addDelivery.delay_delivery = '';
        state.addDelivery.order_id = row.order_id;
        state.addDelivery.delay_delivery = row.delay_delivery;
        state.addDelivery.delay_delivery_time = row.delay_delivery_time;
        state.addDelivery.user_id = store.state.user.userInfo.id;
        state.dialogDeliveryFormVisible = true;
      },
      submitAddDelivery: () => {
        proxy.$refs['addDeliveryForm'].validate(value => {
          if (value) {
            //提交物流信息
            proxy.$http.post(`/admin/merchant/delay_delivery`, state.addDelivery).then(res => {
              if (res.code == 0) {
                proxy.$message({
                  type: 'success',
                  message: res.msg
                });
              } else {
                proxy.$message({
                  type: 'error',
                  message: res.msg
                });
              }
            });
          }
        });
      },
      // 获取物流公司信息
      getExpressInfo: async () => {
        state.expressPhoneError = "";
        const {
          express_no
        } = state.addExpressCp;
        if (!express_no) {
          row.express_cp = '';
          state.addExpressCp.disabled = false;
          return;
        }
        const {
          code,
          data,
          msg
        } = await getExpressInfoApi(express_no);
        if (code == 200) {
          // 更新当前 field 的物流公司信息
          state.addExpressCp.express_cp = data.current_express_no;
          state.addExpressCp.disabled = true;
        } else {
          proxy.$message({
            type: 'error',
            message: msg
          });
          state.addExpressCp.disabled = false;
          state.addExpressCp.express_cp = '';
        }
      },
      // 手机号输入时过滤非数字
      handleInput: value => {
        state.addExpressCp.originator_phone = value.replace(/\D-/g, '');
      },
      submitAddExpressCp: () => {
        const {
          addExpressCp
        } = state;
        const {
          isNotice,
          express_cp
        } = addExpressCp;
        proxy.$refs['addExpressCpForm'].validate(val => {
          if (val) {
            //检验京东、顺丰快递输入是否合理
            // 假设 express_cp 是一个字符串变量，包含当前的快递公司名称
            // 假设 isNotice 是一个数字变量，表示特定的通知类型

            // 根据isNotice值和express_cp内容更新noticeMessage
            if (isNotice === 1 && !express_cp.includes('京东') && isNotice === 1 && !express_cp.includes('顺丰') || isNotice === 2 && !express_cp.includes('京东') || isNotice === 3 && !express_cp.includes('顺丰')) {
              state.displayMessage = state.addExpressCp.isNotice > 0 ? state.noticeArray[state.addExpressCp.isNotice - 1] : '';
              // noticeMessage = isNotice; // 直接使用isNotice的值
            } else {
              //提交物流信息
              proxy.$http.post(`/admin/merchant/add_express`, state.addExpressCp).then(res => {
                if (res.code == 200) {
                  proxy.$message({
                    type: 'success',
                    message: res.msg
                  });
                  state.dialogOldFormVisible = false;
                  state.getList();
                } else {
                  proxy.$message({
                    type: 'error',
                    message: res.msg
                  });
                }
              });
            }
          }
        });
      },
      closeAddExpressCpDialog: () => {
        state.expressPhoneError = "";
        state.dialogOldFormVisible = false;
      },
      orderEdit: (index, row) => {
        router.push('/merchant-admin/order-edit?order_id=' + row.order_id);
      },
      getSpanArr: resData => {
        state.spanArr = [];
        if (resData === null) {
          return;
        }
        for (let i = 0; i < resData.length; i++) {
          if (i === 0) {
            state.spanArr.push(1);
            state.pos = 0;
          } else {
            if (resData[i].order_id === resData[i - 1].order_id) {
              state.spanArr[state.pos] += 1;
              state.spanArr.push(0);
            } else {
              resData[i].hasClass = true;
              state.spanArr.push(1);
              state.pos = i;
            }
          }
        }
      },
      objectSpanMethod: ({
        row,
        column,
        rowIndex,
        columnIndex
      }) => {
        let columnArray = [0, 4, 5, 6, 8, 9, 12, 14];
        if (state.filters.is_yushou == 1) {
          columnArray = [0, 4, 5, 6, 8, 11, 13];
        }
        if (columnArray.includes(columnIndex)) {
          const _row = state.spanArr[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          return {
            rowspan: _row,
            colspan: _col
          };
        }
      },
      // 合并后的表格添加样式
      rowClassName: ({
        row
      }) => {
        if (row.hasClass) {
          return 'deep-border';
        }
        if (row.status == 3) {
          return 'warning-row';
        }
      },
      // 打开关注微信公众号弹框
      onOpenFollowDialog: () => {
        nextTick(() => {
          proxy.$refs.followWxDialog.openFollowDialog();
        });
      },
      // 下载手册文件
      onPreview: () => {
        window.open('https://dgss-oss-zs.oss-cn-beijing.aliyuncs.com/shop_vedio/收费附件添加教程1723017670.docx');
      }
    });

    // 校验延迟类型
    const validDelayType = (rule, val, callback) => {
      if (val == 0) {
        callback(new Error('请选择延迟发货类型'));
      } else {
        callback();
      }
    };
    // 校验延迟时间
    const validDelayTime = (rule, val, callback) => {
      if (val == '0000-00-00 00:00:00') {
        callback(new Error('请选择延迟发货类型'));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, val, callback) => {
      // 处理表单验证的情况
      const ship_flag = state.addExpressCp.ship_type !== 'same';
      if (ship_flag && val != '') {
        if (!isValidTel(val) && !isValidMobile(val)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    const validateExpressPhone = phone => {
      if (phone != "") {
        if (!isValidTel(phone) && !isValidMobile(phone)) {
          state.expressPhoneError = "手机号或者座机格式错误,例如：13888888888或010-12345678";
        } else {
          state.expressPhoneError = "";
        }
      }
    };
    const deliveryRules = reactive({
      delay_delivery_type: [{
        required: true,
        message: '请选择延迟发货类型',
        trigger: 'change'
      }, {
        validator: validDelayType,
        trigger: 'change'
      }],
      delay_delivery_time: [{
        required: true,
        message: '请选择延迟发货时间',
        trigger: 'change'
      }, {
        validator: validDelayTime,
        trigger: 'change'
      }],
      delay_reson: [{
        required: true,
        message: '请填写延迟发货原因',
        trigger: 'blur'
      }]
    });
    const expressCpRules = reactive({
      express_cp: [{
        required: true,
        message: '请填写发货公司或者快递员姓名',
        trigger: 'blur'
      }, {
        validator: check_zh,
        trigger: 'blur'
      }],
      express_no: [{
        required: true,
        message: '请填写物流单号或者快递员电话',
        trigger: 'blur'
      }],
      originator_phone: [
      // { required: true, message: '请填写寄件人手机号', trigger: 'blur' },
      {
        validator: validatePhone,
        trigger: 'blur'
      }]
    });

    /**
     *  设置 商品无货、其他 状态下，可选延迟发货时间列表
     *  商品无货情况下，延迟发货只能选择 支付时间 + 48小时 + 30 的时间，即[30]
     *  其他情况下，延迟发货只能选择 支付时间 + 30 的时间，即[30]
     * */
    const selectableTimeList = computed(() => {
      const {
        paid_at,
        delay_delivery_type
      } = state.currRow;
      let dateArr = [];
      if (delay_delivery_type == DelayTypes['商品无货'] || delay_delivery_type == DelayTypes['其他']) {
        dateArr = [2, 3, 4, 5, 6, 7];
      }
      // 将 paid_at 转换为 Date 对象
      let paidAtDate = new Date(paid_at);

      // 提取 paid_at 的年、月、日，并将时、分、秒设为 23:59:59
      let stopTime = `${paidAtDate.getFullYear()}-${String(paidAtDate.getMonth() + 1).padStart(2, '0')}-${String(paidAtDate.getDate()).padStart(2, '0')} 23:59:59`;
      let timeList = dateArr.map(item => getDelayTime(stopTime, item));
      return timeList;
    });
    // const displayMessage = computed(() => {
    //    // 假设 state.noticeArray 是一个数组，包含所有可能的通知消息
    //     // 注意：这里假设 noticeMessage 的值恰好对应 state.noticeArray 的索引
    //     return state.addExpressCp.isNotice > 0 ? state.noticeArray[state.addExpressCp.isNotice - 1] : '';
    // })
    // 设置 table 高度
    const setTableHeight = () => {
      nextTick(() => {
        let headerHeight = 50,
          // 头部高度
          filterHeight = proxy.$refs.filterContainer.offsetHeight + 30,
          // 搜索条件框高度 + 间距
          paginationHeight = 62; // 分页栏高度 + 与 table 之间的间距
        state.tableHeight = window.innerHeight - headerHeight - filterHeight - paginationHeight;
      });
    };
    // 设置 table 高度
    setTableHeight();
    // 监听窗口变化，重置 table 高度
    window.onresize = setTableHeight;
    const rowClassName = ({
      row
    }) => {
      if (row.status == 3) {
        return 'warning-row';
      }
    };
    // 注销 onresize 监听
    onBeforeRouteLeave(() => {
      window.onresize = null;
    });
    watch(() => router.currentRoute.value, (newVal, oldVal) => {
      if (newVal.path === oldVal.path) {
        //若有则传递新的值，没有传默认的0
        state.filters.is_yushou = newVal.query.is_yushou || 0;
        //重新调用接口数据
        state.search();
      }
    });
    onActivated(() => {
      if (route.query.o == 'order') {
        state.filters.order_type = route.query.all;
        state.filters.start_date = route.query.start_date || getLastMonthToday();
        state.filters.end_date = route.query.end_date || getCurrentDate();
        state.filters.delivery_type = route.query.t || '', state.filters.page = 1;
      }
      state.getList();
    });
    hasShop && state.getShopList();
    return {
      ...toRefs(state),
      rowClassName,
      router,
      hasShop,
      is_allocation,
      expressCpRules,
      deliveryRules,
      Keys,
      deliveryTypes,
      store,
      DelayStatus,
      DelayTypes,
      selectableTimeList,
      disabledDate,
      disabledStartDate,
      disabledEndDate,
      OrderPickStatus,
      FollowWxDialog,
      validateExpressPhone
    };
  }
});